/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Lot_Ballot_ReturnedInputs */

const vi_tea_lot_ballot_returned = /** @type {(inputs: Tea_Lot_Ballot_ReturnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã trả phiếu`)
};

/**

* @param {Tea_Lot_Ballot_ReturnedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_lot_ballot_returned = /** @type {((inputs?: Tea_Lot_Ballot_ReturnedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Lot_Ballot_ReturnedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_lot_ballot_returned(inputs)
});